import { render, staticRenderFns } from "./pi-export.vue?vue&type=template&id=4b8a3468"
import script from "./pi-export.vue?vue&type=script&lang=ts"
export * from "./pi-export.vue?vue&type=script&lang=ts"
import style0 from "./pi-export.vue?vue&type=style&index=0&id=4b8a3468&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports